// src/app/reasons/reasons.service.ts

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

// Optional: Define an interface for better type safety
export interface TransferOutReason {
  id: string;
  type: string;
  code: string | null;
  description: string;
  shortReason: string;
  // Add other properties if needed
  isActive: boolean;
}

@Injectable({
  // 'root' means the service is provided at the application level
  providedIn: 'root',
})
export class ReasonsService {
  private http = inject(HttpClient);
  // COMMENT: Define the API endpoint for fetching all reasons
  private apiUrl = `${environment.apiUrl}/api/reasons/all`;

  constructor() {
    // The HttpClient is injected via `inject` above, so the constructor can be empty
  }

  /**
   * Fetches all available reasons from the backend API.
   * @returns An Observable of the API response, expected to be an array of reasons.
   */
  getAllReasons(): Observable<TransferOutReason[]> {
    // COMMENT: HTTP GET request to the defined API endpoint
    return this.http.get<TransferOutReason[]>(this.apiUrl);
  }
}
